export default "__VITE_ASSET__DJ5UKBTG__"